import type { GetPropertyByIdQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { allPropertiesDetail } from '~/msw/mocks/property'
import { trackingArchive } from '~/msw/mocks/property/lifecycle'

/**
 * Scénario « archivé » : le bien est vendu, aucune transition n'est proposée et le badge de
 * sous-statut n'ouvre plus de menu.
 */
export function getPropertyArchivedHandler() {
  return http.get<
    { id: string },
    never,
    GetPropertyByIdQueryResponse
  >('http://localhost:3000/api/v1/property/:id', async ({ params }) => {
    const annonce = allPropertiesDetail.find(annonce => annonce.id === params.id)
    return HttpResponse.json(annonce && { ...annonce, trackingStatus: trackingArchive })
  })
}
